module.exports = __webpack_public_path__ + "img/s2-img.24c82ad2.png";